// AdminApp - super-admin UI. Adds "Integration requests" under Customer success.
import { useEffect, useState } from 'react';
import {
  LayoutDashboard, Building2, Users, Flag, ShieldCheck, FileSearch, Crown, Inbox, Plug, BookOpen, CreditCard, Cpu,
} from 'lucide-react';
import { AppShell } from '@govern360/shared';
import OverviewPage from './pages/OverviewPage.jsx';
import TenantsPage from './pages/TenantsPage.jsx';
import LicensesPage from './pages/LicensesPage.jsx';
import OrgRequestsPage from './pages/OrgRequestsPage.jsx';
import IntegrationRequestsPage from './pages/IntegrationRequestsPage.jsx';
import StaffPage from './pages/StaffPage.jsx';
import FlagsPage from './pages/FlagsPage.jsx';
import DetectorsPage from './pages/DetectorsPage.jsx';
import ModelAdvisoriesPage from './pages/ModelAdvisoriesPage.jsx'; // G360_K516
import AuditAllPage from './pages/AuditAllPage.jsx';
import CapabilitiesPage from './pages/CapabilitiesPage.jsx';

const PAGES = {
  overview: OverviewPage,
  tenants: TenantsPage,
  licenses: LicensesPage,
  orgrequests: OrgRequestsPage,
  integrationrequests: IntegrationRequestsPage,
  staff: StaffPage,
  flags: FlagsPage,
  detectors: DetectorsPage,
  advisories: ModelAdvisoriesPage,
  auditall: AuditAllPage,
  capabilities: CapabilitiesPage,
};
function readHash() {
  const h = (window.location.hash || '#overview').slice(1);
  return h.split('?')[0] || 'overview';
}
export default function AdminApp() {
  const [route, setRoute] = useState(readHash());
  useEffect(() => {
    const onHash = () => setRoute(readHash());
    window.addEventListener('hashchange', onHash);
    if (!window.location.hash) window.location.hash = '#overview';
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  const NAV_GROUPS = [
    {
      label: 'Customer success',
      items: [
        { id: 'overview', label: 'Platform overview', icon: LayoutDashboard, route: 'overview' },
        { id: 'tenants',  label: 'Tenants',           icon: Building2,       route: 'tenants' },
        { id: 'licenses', label: 'Licences & usage',  icon: CreditCard,      route: 'licenses' },
        { id: 'orgrequests', label: 'Org requests',   icon: Inbox,           route: 'orgrequests' },
        { id: 'integrationrequests', label: 'Integration requests', icon: Plug, route: 'integrationrequests' },
        { id: 'staff',    label: 'Staff & roles',     icon: Users,           route: 'staff' },
      ],
    },
    {
      label: 'Platform',
      items: [
        { id: 'flags',     label: 'Feature flags',    icon: Flag,     route: 'flags' },
        { id: 'detectors', label: 'Global detectors', icon: ShieldCheck, route: 'detectors' },
        { id: 'advisories', label: 'Model advisories', icon: Cpu, route: 'advisories' },
        { id: 'capabilities', label: 'Capabilities', icon: BookOpen, route: 'capabilities' },
      ],
    },
    {
      label: 'Security',
      items: [
        { id: 'auditall', label: 'Cross-tenant audit', icon: FileSearch, route: 'auditall' },
      ],
    },
  ];
  function navigate(r) { window.location.hash = `#${r}`; }
  const PageComponent = PAGES[route] || OverviewPage;
  const topBar = <span className="ap-chip admin"><Crown size={14} />Super admin</span>;
  return (
    <AppShell navGroups={NAV_GROUPS} currentRoute={route} onNavigate={navigate} topBar={topBar}>
      <PageComponent route={route} />
    </AppShell>
  );
}
